<template>
	<div v-if="data && fieldList.length" class="custom-detail">
		<c-detail-item v-for="(field, i) in fieldList" :key="i" :label="field.field_title">
			<div v-if="['file', 'image'].includes(field.config_json.type)" class="flex-grow flex-wrap file-list">
				<template v-if="data[field.field_code]">
					<template v-if="typeof data[field.field_code] == 'string'">
						<c-file v-for="(item, i) in data[field.field_code].split(',')" :key="i" :src="item" :media="field.config_json.type == 'image'" :preview="data[field.field_code].split(',')" @click.native.stop></c-file>
					</template>
					<template v-else>
						<c-file v-for="(item, i) in data[field.field_code]" :key="i" :src="item" :media="field.config_json.type == 'image'" :preview="data[field.field_code]" @click.native.stop></c-file>
					</template>
				</template>
			</div>
			<c-tags v-else-if="typeof data[field.field_code] == 'object'" :value="data[field.field_code]"></c-tags>
			<span v-else>{{data[field.field_code] || '-'}}</span>
		</c-detail-item>
	</div>
</template>

<script>
	export default {
		name: 'customDetail',

		props: {
			workType: [String, Number],
			data: Object
		},

		data() {
			return {
				fieldList: []
			}
		},

		mounted() {
			this.request({
				url: '/sys_field/list',
				data: {
					work_type_id: this.workType
				},
				success: data => {
					this.fieldList = data;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.custom-detail {
		width: 100%;
		
		.file-list {
			gap: .1rem;
			
			>>> .c-file-media {
				width: .8rem;
				height: .8rem;
			}
		}
	}
</style>
